import { ACTION_TYPES } from '../../constants/protocol';
import { useEffect, useState } from 'react';

import styled from 'styled-components';
import { flexDirectionColumn, layerA } from '../styles/commonStyles';

import TitleContainer from '../TitleContainer';
import AuditTrailComponentBySwitch from './AuditTrailComponentBySwitch';
import ATMainSelect from './ATMainSelect';

import {
  extractUniquePropertyValues,
  formatTime,
  getLocationAssignedUsersByDeviceIds,
} from '../../helpers/helpers';
import { getAuditTrailService } from '../../services/auditTrail.service';
import { useSelector } from 'react-redux';
import { selectLocations } from '../store/slices/locationsSlice';
import { useCheckControlPermsission } from '../../hooks';

const AuditTrailMain = () => {
  const [isReadyToRender, setIsReadyToRender] = useState(false);
  const [userSelect, setUserSelect] = useState([]);
  const [auditTrailData, setAuditTrailData] = useState({});
  const checkSwitchPermission=useCheckControlPermsission();
  const locations = useSelector(selectLocations);
  const { all: allLocations } = locations;
  const [disableSettings, setDisableSettings] = useState(false);
  const [searchQuery, setSearchQuery] = useState(null);
  const AUDIT_TRAIL_Action = [
    ACTION_TYPES.MASTER_CONTROL,
    ACTION_TYPES.GLOBAL_MASTER_CONTROL,
    ACTION_TYPES.FAST_MASTER_CONTROL,
    ACTION_TYPES.LOCAL_MASTER_CONTROL,
    ACTION_TYPES.SSR_RESET,
    ACTION_TYPES.THERMOCOUPLE_RESET,
    ACTION_TYPES.GROUND_RESET,
    ACTION_TYPES.HPLP_RESET,
    ACTION_TYPES.LOAD_EXCEED_RESET,
    ACTION_TYPES.TIMEOUT_RESET,
    ACTION_TYPES.BMS_RESET,
    ACTION_TYPES.GLOBAL_TELEMETRY_OVERVIEW,
    ACTION_TYPES.ACTION,
  ];

  const componentsStatus = {
    ess: checkSwitchPermission('ess'),
    tgs: checkSwitchPermission('tgs'),
    tes: checkSwitchPermission('tes'),
    hp: checkSwitchPermission('hp'),
    ate: checkSwitchPermission('ate'),
    setting: true,
    aat: true,
  };

  const handleUserSelect = async (selectedData) => {
   
    const startDate = formatTime(selectedData[1].start, true);
    const endDate = formatTime(selectedData[1].end, true);
    if (selectedData[0]) {

      setUserSelect(selectedData);
      const userIds = extractUniquePropertyValues(selectedData[2], 'user_id');
      const AuditTrailPayload = (actionType = '', deviceType = '') => ({
        userIds,
        startDate,
        endDate,
        actionType: actionType,
        deviceType: deviceType,
      });
      const settingsByUesrnamePayload = {
        startDate,
        endDate,
        actionType: [ACTION_TYPES.AUTH, ACTION_TYPES.SETTING, ACTION_TYPES.HEAT_CONFIGURATION],
        userIds: userIds,
      };
      const additionalActionTakenByUsernamePayload = {
        startDate,
        endDate,
        userIds,
        actionType: [ACTION_TYPES.GLOBAL_DATA_TELEMETRY_OVERVIEW, ACTION_TYPES.AUDIT_TRAIL],
      };
      const allAduitTrail = {
        EssActions: getAuditTrailService(
          AuditTrailPayload(AUDIT_TRAIL_Action, 'ESS'),
          200
        ),
        EssFaults: getAuditTrailService(
          AuditTrailPayload(['FAULT'], 'ESS'),
          200
        ),
        TesActions: getAuditTrailService(
          AuditTrailPayload(AUDIT_TRAIL_Action, 'TES'),
          200
        ),
        TesFaults: getAuditTrailService(
          AuditTrailPayload(['FAULT'], 'TES'),
          200
        ),
        TgsActions: getAuditTrailService(
          AuditTrailPayload(AUDIT_TRAIL_Action, 'TGS'),
          200
        ),
        TgsFaults: getAuditTrailService(
          AuditTrailPayload(['FAULT'], 'TGS'),
          200
        ),
        settings: getAuditTrailService(settingsByUesrnamePayload, 1000),
        additionalActionTaken: getAuditTrailService(
          additionalActionTakenByUsernamePayload,
          1000
        ),
      };
      setSearchQuery(AuditTrailPayload());

      const promises = Object.values(allAduitTrail);
      await Promise.all(promises)
        .then((results) => {
          let AduitTrailData = {
            ess: {
              actions: results[0],
              faults: results[1],
            },
            tes: {
              actions: results[2],
              faults: results[3],
            },
            tgs: {
              actions: results[4],
              faults: results[5],
            },
            setting: results[6],
            aat: results[7],
            hp: {},
            ate: {},
          };
          setAuditTrailData(AduitTrailData);
          setIsReadyToRender(true);
        })
        .catch((error) => {
          throw error;
        });
    } else {
      const deviceIds = extractUniquePropertyValues(selectedData[2], 'machine');
      setUserSelect(selectedData);
      const AuditTrailPayload = (actionType = '', deviceType = '') => ({
        deviceIds,
        startDate,
        endDate,
        actionType: actionType,
        deviceType: deviceType,
      });

      const settingsByLoctionPayload = {
        startDate,
        endDate,
        actionType: [ACTION_TYPES.SETTING, ACTION_TYPES.HEAT_CONFIGURATION],
        userIds: getLocationAssignedUsersByDeviceIds(deviceIds, allLocations),
      };
      const additionalActionTakenByLoctionPayload = {
        startDate,
        endDate,
        deviceIds,
        actionType: [ACTION_TYPES.GLOBAL_DATA_TELEMETRY_OVERVIEW, ACTION_TYPES.AUDIT_TRAIL],
      };
      const allAduitTrail = {
        EssActions: getAuditTrailService(
          AuditTrailPayload(AUDIT_TRAIL_Action, 'ESS'),
          200
        ),
        EssFaults: getAuditTrailService(
          AuditTrailPayload(['FAULT'], 'ESS'),
          1000
        ),
        TesActions: getAuditTrailService(
          AuditTrailPayload(AUDIT_TRAIL_Action, 'TES'),
          200
        ),
        TesFaults: getAuditTrailService(
          AuditTrailPayload(['FAULT'], 'TES'),
          1000
        ),
        TgsActions: getAuditTrailService(
          AuditTrailPayload(AUDIT_TRAIL_Action, 'TGS'),
          200
        ),
        TgsFaults: getAuditTrailService(
          AuditTrailPayload(['FAULT'], 'TGS'),
          200
        ),
        settings: getAuditTrailService(settingsByLoctionPayload, 1000),
        additionalActionTaken: getAuditTrailService(
          additionalActionTakenByLoctionPayload,
          1000
        ),
      };
      setSearchQuery(AuditTrailPayload());

      const promises = Object.values(allAduitTrail);
      await Promise.all(promises)
        .then((results) => {
          let AduitTrailData = {
            ess: {
              actions: results[0],
              faults: results[1],
            },
            tes: {
              actions: results[2],
              faults: results[3],
            },
            tgs: {
              actions: results[4],
              faults: results[5],
            },
            setting: results[6],
            aat: results[7],
            hp: {},
            ate: {},
          };
          setAuditTrailData(AduitTrailData);
          setIsReadyToRender(true);
        })
        .catch((error) => {
          throw error;
        });
    }
  };

  useEffect(() => {}, []);

  return (
    <Wrapper>
      <TitleContainer title='audit trail' />
      <ATMainSelect
        isReadyToRender={isReadyToRender}
        handleSelection={handleUserSelect}
        setDisableSettings={setDisableSettings}
      />
      <SectionMain>
        {Object.keys(componentsStatus).map((component, index) => {
          return (
            <AuditTrailComponentBySwitch
              key={index}
              componentName={component}
              isReadyToRender={isReadyToRender}
              active={componentsStatus[component]}
              userSelect={userSelect}
              data={auditTrailData[component] ?? {}}
              disableSettings={disableSettings}
              searchQuery={searchQuery}
            />
          );
        })}
      </SectionMain>
    </Wrapper>
  );
};

export default AuditTrailMain;

const Wrapper = styled.div`
  min-height: 674rem;
  width: 1216rem;
`;

const SectionMain = styled.section`
  width: 1216px;

  border-radius: 40px 40px 40px 40px;
  ${layerA}
  ${flexDirectionColumn}
  padding: 2px 0;
`;
